/* SubmitButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';
import Enter from '../../assets/Enter';
import messages from './messages';
export var SubmitButton = function SubmitButton(_ref) {
  var disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    onClick = _ref.onClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: formatMessage(messages.submitTooltip),
    hideTooltipOnClick: true,
    position: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: formatMessage(messages.submitLabel),
    onClick: onClick,
    testId: "submit-icon-button",
    isDisabled: disabled,
    icon: Enter,
    appearance: "subtle",
    spacing: "compact",
    tabIndex: tabIndex
  }));
};